import { render, staticRenderFns } from "./HeaderLogged.vue?vue&type=template&id=48a55c6f&scoped=true"
import script from "./HeaderLogged.vue?vue&type=script&lang=js"
export * from "./HeaderLogged.vue?vue&type=script&lang=js"
import style0 from "./HeaderLogged.vue?vue&type=style&index=0&id=48a55c6f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a55c6f",
  null
  
)

export default component.exports